import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" {...props}>
		<path d="M31.57 18.13L20.75 7.318Q18.2 4.1 15.66 7.32L14.63 8.35C18.1 12.1 13 17.5 9.06 13.92L8.03 14.96Q4.8 17.5 8.03 20.05L18.84 30.87Q21.4 34.1 23.94 30.87L24.97 29.83C21.4 25.8 26.8 20.8 30.54 24.26L31.57 23.23Q34.8 20.7 31.57 18.14Z" />
	</svg>
);
